export default {
  NUMERIC: 'numeric',
  DATE: 'date',
};
